<app-dialog-container
    *ngIf="filters"
    (closeEvent)="closeDialog()"
    [title]="'Orders'"
    [loading]="false"
>
    <div class="ra-primary-blue has-text-centered label-wrapper">
        <label class="has-text-weight-semibold">Orders</label>
    </div>
    <div class="level input-line">
        <div class="level-left">
            <app-filter-input [property]="filters.flightStart"></app-filter-input>
            <app-filter-input [property]="filters.flightEnd"></app-filter-input>
            <app-filter-input [property]="filters.demographics"></app-filter-input>
            <app-filter-input [property]="filters.categories"></app-filter-input>
            <!--            <app-filter-input [Property]="filters.salesRegions"></app-filter-input>-->
            <app-filter-input [property]="filters.accountExecutives"></app-filter-input>

            <app-button
                [buttonText]="'Apply Filters'"
                [icon]="'fas fa-sync-alt'"
                (buttonClick)="applyFilters()"
                [type]="'flat'"
                [disabled]="isFiltering || isAnyFilterLoading"
                [isLoading]="isFiltering"
            />
        </div>
    </div>
    <div class="advertiser-insights-orders-wrapper">
        <ag-grid-angular
            class="ag-theme-material advertiser-insights-orders-grid"
            [rowData]="rowData"
            [columnDefs]="colDefs"
            [domLayout]="'autoHeight'"
            [suppressColumnVirtualisation]="true"
            [stopEditingWhenCellsLoseFocus]="true"
            [suppressContextMenu]="true"
            [defaultColDef]="defaultColDef"
            [excelStyles]="excelStyles"
            (gridReady)="onGridReadyAutoSize($event)"
            (gridColumnsChanged)="gridApi?.autoSizeAllColumns()"
            [overlayNoRowsTemplate]="noRowsOverlay"
        >
        </ag-grid-angular>
    </div>
    <div class="level is-full-width margin-top-75-em">
        <div class="level-left"></div>
        <div class="level-right">
            <app-button
                [buttonText]="'Excel Export'"
                [icon]="'fas fa-file-excel'"
                (buttonClick)="exportOrdersToExcel()"
                [type]="'flat'"
                [disabled]="!rowData?.length || isFiltering"
            />
            <app-button
                [buttonText]="'Get Data'"
                [icon]="'fas fa-save'"
                (buttonClick)="save()"
                [type]="'flat'"
                [disabled]="isFiltering"
                [isLoading]="isFiltering"
            />
            <button
                class="button level-item is-danger"
                [disabled]="isFiltering"
                (click)="closeDialog()"
            >
                <span class="icon">
                    <i
                        *ngIf="!isFiltering"
                        class="fas fa-times has-text-white"
                        aria-hidden="true"
                    ></i>
                    <mat-spinner
                        *ngIf="isFiltering"
                        [diameter]="15"
                    ></mat-spinner>
                </span>
                <span class="has-text-white">Cancel</span>
            </button>
        </div>
    </div>
</app-dialog-container>
